import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

import { ConfigurationService } from '../configuration.service';
import { UploadedFile } from '../firestore-models/uploaded-file';
import { ApiUploadedFile} from '../api-client-module';

import { AppConst } from '../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-voice-file-dialog',
  templateUrl: './select-voice-file-dialog.component.html',
  styleUrls: ['./select-voice-file-dialog.component.css'],
  standalone: false,
})
export class SelectVoiceFileDialogComponent implements OnInit, OnDestroy {

  private uploadedFilesCollection!: AngularFirestoreCollection<UploadedFile>;
  uploadedFilesObservable!: Observable<UploadedFile[]>;
  uploadedFilesSubscribe!: Subscription;
  projectId: string;

  displayedColumns: string[] = ['position', 'select', 'name', 'date'];
  dataSource = new MatTableDataSource<UploadedFile>();

  currentLang: string = 'ja';

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<SelectVoiceFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApiUploadedFile,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.uploadedFilesCollection = this.angularFirestore.collection<UploadedFile>(
      AppConst.FIRESTORE_UPLOADED_FILES, ref => ref.where('project_id', '==', this.projectId).orderBy('created', 'desc'));
    this.uploadedFilesObservable = this.uploadedFilesCollection.valueChanges({ idField: 'id' });
    this.uploadedFilesSubscribe = this.uploadedFilesObservable.subscribe(uploadedFiles => {
      let data = [];
      for (const uploadedFile of uploadedFiles) {
        if (this.isMp3(uploadedFile)) {
          data.push(uploadedFile);
        }
      }
      this.dataSource.data = data;
    });
    this.currentLang = this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.uploadedFilesSubscribe.unsubscribe();
  }

  selectFile(row: UploadedFile) {
    let uploadedFile: ApiUploadedFile = {
      id: row.id,
      type: row.type ? row.type : '',
      file_name: row.file_name,
      file_path: row.file_path,
      download_url: row.download_url,
      project_id: row.project_id,
      enabled: row.enabled
    }
    this.dialogRef.close(uploadedFile);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isMp3(uploadedFile: UploadedFile): boolean {
    // 拡張子取得
    const pos = uploadedFile.file_name.lastIndexOf('.');
    let ext = '';
    if (pos !== -1) {
      ext = uploadedFile.file_name.slice(pos + 1).toLowerCase();
    }
    if (ext !== 'mp3') {
      return false;
    }
    return true
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string, b: number | string, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.file_name.substr(14), b.file_name.substr(14), isAsc);
        case 'date':
          return compare(a.created.toString(), b.created.toString(), isAsc);
        default:
          return 0;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
